// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  margin: 8mm;
  size: A4 landscape;
}

.weekly-sheet-preview {
  background: #fff;
  box-sizing: border-box;
  color: #172033;
  padding: 12px;
}

.weekly-sheet-toolbar {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.weekly-sheet-summary {
  display: block;
  margin-bottom: 10px;
}

.weekly-sheet-state {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 220px;
}

.weekly-sheet-days {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.weekly-sheet-day {
  page-break-inside: avoid;
  break-inside: avoid;
}

.weekly-sheet-day h3 {
  background: #d9eaf7;
  border: 1px solid #8f8f8f;
  font-size: 14px;
  margin: 0;
  padding: 6px 8px;
  text-align: center;
}

.weekly-sheet-blocks {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 8px;
}

.weekly-sheet-block {
  page-break-inside: avoid;
  break-inside: avoid;
  min-width: 0;
}

.weekly-sheet-block-title {
  align-items: center;
  background: #eef6fb;
  border: 1px solid #8f8f8f;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  gap: 2px;
  min-height: 52px;
  justify-content: center;
  padding: 4px;
  text-align: center;
}

.weekly-sheet-block table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.weekly-sheet-block th,
.weekly-sheet-block td {
  border: 1px solid #8f8f8f;
  font-size: 11px;
  overflow-wrap: anywhere;
  padding: 4px;
  text-align: left;
  vertical-align: middle;
}

.weekly-sheet-block th {
  background: #5b9bd5;
  color: #fff;
  font-weight: 700;
  text-align: center;
}

.weekly-sheet-block th:first-child,
.weekly-sheet-block th:nth-child(3),
.weekly-sheet-block td.weekly-sheet-time-cell,
.weekly-sheet-block td.weekly-sheet-age-cell,
.weekly-sheet-block td.weekly-sheet-level-cell {
  text-align: center;
}

.weekly-sheet-block th:first-child,
.weekly-sheet-block td.weekly-sheet-time-cell {
  width: 16%;
}

.weekly-sheet-block th:nth-child(2),
.weekly-sheet-block td.weekly-sheet-student-cell {
  width: 42%;
  text-align: center;
}

.weekly-sheet-block th:nth-child(3),
.weekly-sheet-block td.weekly-sheet-age-cell {
  width: 16%;
}

.weekly-sheet-block th:nth-child(4),
.weekly-sheet-block td.weekly-sheet-level-cell {
  width: 26%;
}

.weekly-sheet-empty {
  border: 1px solid #8f8f8f;
  color: #566274;
  padding: 12px;
  text-align: center;
}

@media print {
  .weekly-sheet-preview {
    min-width: 0;
    padding: 0 !important;
    width: 100% !important;
  }

  .weekly-sheet-toolbar,
  .weekly-sheet-summary {
    display: none;
  }

  .weekly-sheet-days {
    gap: 10px;
    width: 100%;
  }

  .weekly-sheet-blocks {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .weekly-sheet-day {
    page-break-inside: avoid;
    width: 100%;
  }

  .weekly-sheet-block {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ClassCalendar/WeeklyClassSheetPreview.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@page {\n  margin: 8mm;\n  size: A4 landscape;\n}\n\n.weekly-sheet-preview {\n  background: #fff;\n  box-sizing: border-box;\n  color: #172033;\n  padding: 12px;\n}\n\n.weekly-sheet-toolbar {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.weekly-sheet-summary {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.weekly-sheet-state {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 220px;\n}\n\n.weekly-sheet-days {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.weekly-sheet-day {\n  break-inside: avoid;\n}\n\n.weekly-sheet-day h3 {\n  background: #d9eaf7;\n  border: 1px solid #8f8f8f;\n  font-size: 14px;\n  margin: 0;\n  padding: 6px 8px;\n  text-align: center;\n}\n\n.weekly-sheet-blocks {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 8px;\n}\n\n.weekly-sheet-block {\n  break-inside: avoid;\n  min-width: 0;\n}\n\n.weekly-sheet-block-title {\n  align-items: center;\n  background: #eef6fb;\n  border: 1px solid #8f8f8f;\n  display: flex;\n  flex-direction: column;\n  font-size: 11px;\n  gap: 2px;\n  min-height: 52px;\n  justify-content: center;\n  padding: 4px;\n  text-align: center;\n}\n\n.weekly-sheet-block table {\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.weekly-sheet-block th,\n.weekly-sheet-block td {\n  border: 1px solid #8f8f8f;\n  font-size: 11px;\n  overflow-wrap: anywhere;\n  padding: 4px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.weekly-sheet-block th {\n  background: #5b9bd5;\n  color: #fff;\n  font-weight: 700;\n  text-align: center;\n}\n\n.weekly-sheet-block th:first-child,\n.weekly-sheet-block th:nth-child(3),\n.weekly-sheet-block td.weekly-sheet-time-cell,\n.weekly-sheet-block td.weekly-sheet-age-cell,\n.weekly-sheet-block td.weekly-sheet-level-cell {\n  text-align: center;\n}\n\n.weekly-sheet-block th:first-child,\n.weekly-sheet-block td.weekly-sheet-time-cell {\n  width: 16%;\n}\n\n.weekly-sheet-block th:nth-child(2),\n.weekly-sheet-block td.weekly-sheet-student-cell {\n  width: 42%;\n  text-align: center;\n}\n\n.weekly-sheet-block th:nth-child(3),\n.weekly-sheet-block td.weekly-sheet-age-cell {\n  width: 16%;\n}\n\n.weekly-sheet-block th:nth-child(4),\n.weekly-sheet-block td.weekly-sheet-level-cell {\n  width: 26%;\n}\n\n.weekly-sheet-empty {\n  border: 1px solid #8f8f8f;\n  color: #566274;\n  padding: 12px;\n  text-align: center;\n}\n\n@media print {\n  .weekly-sheet-preview {\n    min-width: 0;\n    padding: 0 !important;\n    width: 100% !important;\n  }\n\n  .weekly-sheet-toolbar,\n  .weekly-sheet-summary {\n    display: none;\n  }\n\n  .weekly-sheet-days {\n    gap: 10px;\n    width: 100%;\n  }\n\n  .weekly-sheet-blocks {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .weekly-sheet-day {\n    page-break-inside: avoid;\n    width: 100%;\n  }\n\n  .weekly-sheet-block {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
